import { render } from "./DawaDirectoryReport.vue?vue&type=template&id=4e92494c&scoped=true"
import script from "./DawaDirectoryReport.vue?vue&type=script&lang=js"
export * from "./DawaDirectoryReport.vue?vue&type=script&lang=js"

import "./DawaDirectoryReport.vue?vue&type=style&index=0&id=4e92494c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e92494c"]])

export default __exports__